import { FC, ReactNode, useMemo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { contractorKindMessage } from '@/helpers/contractor_kind';

const messages = defineMessages({
  name: {
    id: 'contractor_pane.name',
    defaultMessage: 'Name',
  },
  kind: {
    id: 'contractor_pane.kind',
    defaultMessage: 'Type',
  },
  contact_person: {
    id: 'contractor_pane.contact_person',
    defaultMessage: 'Contact person',
  },
  phone_number: {
    id: 'contractor_pane.phone_number',
    defaultMessage: 'Phone number',
  },
  email: {
    id: 'contractor_pane.email',
    defaultMessage: 'Email',
  },
  allocated_filterset: {
    id: 'contractor_pane.allocated_filterset',
    defaultMessage: 'Allocated filterset',
  },
  no_filterset_selected: {
    id: 'contractor_pane.no_filterset_selected',
    defaultMessage: 'No filterset selected',
  },
  internal_notes: {
    id: 'contractor_pane.internal_notes',
    defaultMessage: 'Internal notes',
  },
  no_notes_available: {
    id: 'contractor_pane.no_notes_available',
    defaultMessage: 'No notes',
  },
});

interface ContractorDetailsProps {
  contractor: Contractor;
  filtersets: FilterSet[];
}

const Field: FC<{ label: ReactNode; children: ReactNode }> = ({
  label,
  children,
}) => (
  <div>
    <dt className="text-xs leading-4 tracking-[0.5px] text-text-800">
      {label}
    </dt>
    <dd className="mb-2 text-base leading-6">{children}</dd>
  </div>
);

const ContractorDetails: FC<ContractorDetailsProps> = ({
  contractor,
  filtersets,
}) => {
  const filterset = useMemo(
    () => filtersets.find((set) => set.id === contractor.filterset_id),
    [contractor.filterset_id, filtersets],
  );

  return (
    <dl>
      <Field label={<FormattedMessage {...messages.name} />}>
        {contractor.name}
      </Field>
      <Field label={<FormattedMessage {...messages.kind} />}>
        <FormattedMessage {...contractorKindMessage(contractor.kind)} />
      </Field>
      <Field label={<FormattedMessage {...messages.contact_person} />}>
        {contractor.contact_person || '-'}
      </Field>
      <Field label={<FormattedMessage {...messages.phone_number} />}>
        {contractor.phone || '-'}
      </Field>
      <Field label={<FormattedMessage {...messages.email} />}>
        {contractor.email || '-'}
      </Field>
      <Field label={<FormattedMessage {...messages.allocated_filterset} />}>
        {filterset ? (
          filterset.name
        ) : (
          <FormattedMessage {...messages.no_filterset_selected} />
        )}
      </Field>
      <Field label={<FormattedMessage {...messages.internal_notes} />}>
        {contractor.notes || (
          <FormattedMessage {...messages.no_notes_available} />
        )}
      </Field>
    </dl>
  );
};

export default ContractorDetails;
